import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import Button from "@material-ui/core/Button";
import { languages } from "../../constants/languages";
import { Tooltip } from "@material-ui/core";

class DeleteDivisionContainer extends Component {
  state = {
    open: false,
    errorMessage: "",
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open, errorMessage: "" });
    }
  };

  handleDelete = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    tournamentRef
      .collection("teams")
      .where("division", "==", this.props.division.id)
      .get()
      .then((querySnapshot) => {
        var teams = [];
        querySnapshot.forEach(function (doc) {
          let team = doc.data();
          teams.push(team);
        });
        if (teams.length === 0) {
          tournamentRef
            .collection("poules")
            .where("division", "==", this.props.division.id)
            .get()
            .then((querySnapshot) => {
              var poules = [];
              querySnapshot.forEach(function (doc) {
                let poule = doc.data();
                poules.push(poule);
              });
              if (poules.length === 0) {
                // delete division
                window.firebase
                  .firestore()
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .collection("divisions")
                  .doc(this.props.division.id)
                  .delete()
                  .then(() => {
                    if (
                      this.props.division.id === this.props.selectedDivision
                    ) {
                      this.props.selectDivision("0");
                    }
                  });
              } else {
                this.setState({
                  errorMessage: languages.formatString(
                    languages.divisions.divisionNotEmpty,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playersLow
                      : languages.tournament.teamsLow
                  ),
                });
              }
            });
        } else {
          this.setState({
            errorMessage: languages.formatString(
              languages.divisions.divisionNotEmpty,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            ),
          });
        }
      });
  };

  render() {
    return (
      <div>
        {this.props.division.id === "0" ? (
          <Tooltip
            disableFocusListener
            title={languages.structure.firstDivisionTooltip}
          >
            <div>
              <Button onClick={this.toggleDialog} disabled>
                {languages.general.delete}
              </Button>
            </div>
          </Tooltip>
        ) : (
          <Button onClick={this.toggleDialog} color="secondary">
            {languages.general.delete}
          </Button>
        )}
        <DeleteDialog
          open={this.state.open}
          division={this.props.division}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          title={languages.divisions.deleteDivision}
          description={languages.divisions.deleteWarning}
        />
      </div>
    );
  }
}

export default DeleteDivisionContainer;
